// tslint:disable
export var IntakeType;
(function (IntakeType) {
    // Call
    IntakeType[IntakeType["Call"] = 1] = "Call";
    // Web
    IntakeType[IntakeType["Web"] = 2] = "Web";
    // Document
    IntakeType[IntakeType["Document"] = 3] = "Document";
    // Datafeed
    IntakeType[IntakeType["Datafeed"] = 4] = "Datafeed";
})(IntakeType || (IntakeType = {}));
IntakeType['CALL'] = 1;
IntakeType['WEB'] = 2;
IntakeType['DOCUMENT'] = 3;
IntakeType['DATAFEED'] = 4;
//# sourceMappingURL=IntakeType.js.map